import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import VueI18n from "vue-i18n";
import messages from "./languages";
import vuetify from "./plugins/vuetify";
import axios from "axios";
import VueAxios from "vue-axios";
import TextHighlight from "vue-text-highlight";

Vue.component("text-highlight", TextHighlight);

Vue.use(VueAxios, axios);
Vue.use(VueI18n);
Vue.config.productionTip = false;

// Conditionally import and use the chatbot plugin
const refcode = localStorage.getItem("refcode");
const env_theme = process.env.VUE_APP_USE_THEME;
let chatbot;
if (
  refcode !== "moph" &&
  refcode !== "niems" &&
  env_theme !== "ADMIN_MOPH" &&
  env_theme !== "NIEMS_ADMIN" &&
  env_theme !== "NIEMS_TRAINING_ADMIN" &&
  env_theme !== "UTCC_JOBFAIR_ADMIN"
) {
  try {
    chatbot = require("./plugins/chatbot").default;
    if (chatbot && chatbot.install) {
      Vue.use(chatbot);
    }
  } catch (error) {
    console.error("Failed to load chatbot plugin:", error);
  }
}

// Add token header to all axios requests
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// Redirect When Token Expire
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      store.commit("logout");
      router.push("/");
    }
    if (error.response && error.response.data) {
      return Promise.reject(error.response.data);
    }
    return Promise.reject(error.message);
  }
);

const envTheme = process.env.VUE_APP_USE_THEME;
const backendUrl = process.env.VUE_APP_BACKEND;

async function getTheme() { 
  try {
    const refCode = localStorage.getItem("refcode");
    const siteName = refCode == "moph" ? "MOPH_ADMIN" : envTheme;

    const { data } = await axios.get(
      `${backendUrl}/api/v1/themes/public/?site_name=${siteName}`
    );

    const themeData = data.data?.[0];
    // console.log('themeData = ', themeData)

    const opacityValue = themeData.theme_colors.landing_page.default_bg_card_opacity || 0.2;
    document.documentElement.style.setProperty('--default_bg_card_opacity', opacityValue);

    if (themeData && vuetify.framework.theme) {
      vuetify.framework.theme.themes.light.default_primary =
        themeData.theme_colors.landing_page.primary;
      vuetify.framework.theme.themes.light.default_dark =
        themeData.theme_colors.landing_page.primary_dark;
      vuetify.framework.theme.themes.light.default_light =
        themeData.theme_colors.landing_page.primary_light;
      vuetify.framework.theme.themes.light.default_primary_v2 =
        themeData.theme_colors.landing_page.primary_v2;
      vuetify.framework.theme.themes.light.default_primary_v2_dark =
        themeData.theme_colors.landing_page.primary_v2_dark;
      vuetify.framework.theme.themes.light.default_primary_v2_light =
        themeData.theme_colors.landing_page.primary_v2_light;
      vuetify.framework.theme.themes.light.text_title_admin =
        themeData.theme_colors.landing_page.primary_v2;
      vuetify.framework.theme.themes.light.text_black =
        themeData.theme_colors.landing_page.text_black;
      vuetify.framework.theme.themes.light.text_detail =
        themeData.theme_colors.landing_page.text_detail;
      vuetify.framework.theme.themes.light.default_text_primary =
        themeData.theme_colors.landing_page.text_primary;
      vuetify.framework.theme.themes.light.default_bg_card =
        themeData.theme_colors.landing_page.default_bg_card;
      vuetify.framework.theme.themes.light.default_bg_card_opacity =
        themeData.theme_colors.landing_page.default_bg_card_opacity;
      vuetify.framework.theme.themes.light.bg_primary =
        themeData.theme_colors.landing_page.bg_primary;
      vuetify.framework.theme.themes.light.bg_primary_v2 =
        themeData.theme_colors.landing_page.bg_primary_v2;
      vuetify.framework.theme.themes.light.bg_primary_register =
        themeData.theme_colors.landing_page.bg_primary_register;
      vuetify.framework.theme.themes.light.bg_text_register =
        themeData.theme_colors.landing_page.bg_text_register;
      vuetify.framework.theme.themes.light.default_button_primary =
        themeData.theme_colors.landing_page.default_button_primary;
      vuetify.framework.theme.themes.light.default_background =
        themeData.theme_colors.landing_page.default_background;
      vuetify.framework.theme.themes.light.default_background_v2 =
        themeData.theme_colors.landing_page.default_background_v2;
      vuetify.framework.theme.themes.light.defualt_active_tab =
        themeData.theme_colors.landing_page.defualt_active_tab;
      vuetify.framework.theme.themes.light.default_chip_primary =
        themeData.theme_colors.landing_page.default_chip_primary;
      vuetify.framework.theme.themes.light.text_title_admin =
        themeData.theme_colors.landing_page.text_title_admin;
      vuetify.framework.theme.themes.light.icon_title_admin_background =
        themeData.theme_colors.landing_page.icon_title_admin_background;
      vuetify.framework.theme.themes.light.chip_primary_light =
        themeData.theme_colors.landing_page.chip_primary_light;
        vuetify.framework.theme.themes.light.filter_chip_background_v2 =
        themeData.theme_colors.landing_page.filter_chip_background_v2;
      vuetify.framework.theme.themes.light.banner = themeData.banner?.file_url;
      vuetify.framework.theme.themes.light.footer_logo =
        themeData.footer_logo?.file_url;
      vuetify.framework.theme.themes.light.logo = themeData.logo?.file_url;

      store.commit("SET_THEME", themeData);
    }

    store.commit("SET_THEME", themeData);
  } catch (err) {
    console.error("ไม่สามารถโหลดธีมจาก API:", err);
  }
}

const langLocale =
  process.env.VUE_APP_USE_THEME === "UTCC_JOBFAIR_ADMIN" ? "en" : "th";

const i18n = new VueI18n({
  locale: langLocale,
  fallbackLocale: "en",
  messages,
});

getTheme().finally(() => {
  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
});
